import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="max-w-md mx-auto px-4 py-24 text-center">
      <p className="font-heading text-7xl text-terracotta-600">404</p>
      <h1 className="font-heading text-2xl text-stone-900 mt-2">Page not found</h1>
      <p className="text-stone-600 mt-1 text-sm">Yeh page exist nahi karta.</p>
      <Link to="/" className="inline-flex items-center mt-6 h-11 px-6 rounded-full bg-stone-900 text-white font-medium">Go home</Link>
    </div>
  );
}
